module.exports = __webpack_public_path__ + "img/LgvLogo_logoOnly.c263e6c2.png";